import { useAppDispatch } from '../../store/reduxHooks';
import { setTechnicalErrorModal } from '../../store/technicalError/technicalError';
import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import './customToastContent.css';
interface CustomToastContentProps {
  message: string;
  endpoint: string;
  params?: Record<string, string | number | boolean | undefined>;
  responseData?: unknown;
  meta?: unknown;
  status?: number;
}

export const CustomToastContent: React.FC<CustomToastContentProps> = ({
  message
}) => {
  const dispatch = useAppDispatch();
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      dispatch(setTechnicalErrorModal(true));
    },
    [dispatch]
  );

  return (
    <div>
      {message}
      <Button
        variant="link"
        type="button"
        role="button"
        onClick={handleClick}
        className="toast-link-btn"
      >
        Подробнее
      </Button>
    </div>
  );
};
